import type { ChakraProps } from "@chakra-ui/react";
import { CheckmarkThickIcon, ImportantIcon } from "styles/icons";
import type { ChecklistIconTypes } from "./CheckList.d";

const checkListPadding: Record<"fill" | "contain", ChakraProps["padding"]> = {
  fill: 0,
  contain: 6,
};

const Icons: ChecklistIconTypes = {
  warning: { icon: ImportantIcon, color: "warning.600" },
  success: { icon: CheckmarkThickIcon, color: "success.600" },
};

export { checkListPadding, Icons };
